import { z } from "zod";

import { RECORD_ACCESS_LEVELS, type RecordAccessLevel } from "./recordAccess";

/**
 * KARŞI KURUM İÇİ ERİŞİM DAĞITIMI (CLOS-1125 · 1157, rapor §9, Halit S3/S4/Guard B).
 *
 * Davet eden yalnız dış TAVANI belirler; hangi çalışanın sözleşmeye erişeceğini karşı kurumun
 * kendi yetkili yöneticisi KENDİ organizasyon bağlamında dağıtır. Hedef kendi aktif üyesi
 * (`membershipId`, ham kullanıcı UUID'si yok); seviye tavanı aşamaz; erişim satırı sahip
 * kiracısında katılıma BAĞLI yazılır (katılım biterse hepsi kapanır).
 */
export const grantSharedContractAccessSchema = z.strictObject({
  membershipId: z.uuid("Geçerli bir üye seçilmelidir"),
  level: z.enum(RECORD_ACCESS_LEVELS).optional(),
});
export const sharedContractAccessParamsSchema = z.strictObject({
  id: z.uuid("Geçerli bir sözleşme kimliği gereklidir"),
  membershipId: z.uuid("Geçerli bir üye seçilmelidir"),
});

export type GrantSharedContractAccessInput = z.infer<typeof grantSharedContractAccessSchema>;

export type SharedContractAccessView = {
  membershipId: string;
  userId: string;
  name: string;
  level: RecordAccessLevel;
  /** Katılımı kabul eden ilk yetkili mi (kart etiketi için). */
  acceptor: boolean;
  grantedByName: string | null;
  startsAt: string;
};

/** Karşı kurum tarafında dağıtım için aday: kendi aktif üyeleri (dizin karşı tarafa GİTMEZ). */
export type SharedContractAccessCandidate = {
  membershipId: string;
  userId: string;
  name: string;
  email: string;
  hasAccess: boolean;
};

export type SharedContractAccessState = {
  /** Katılımın dış tavanı (davette açılan set) ve seviyesi. */
  ceiling: { permissions: string[]; accessLevel: RecordAccessLevel };
  /** Çağıran dağıtım yapabilir mi (kendi kurumunda `contract.share` + kayıt erişimi + kurum katılımı). */
  canDistribute: boolean;
  members: SharedContractAccessView[];
  candidates: SharedContractAccessCandidate[];
};
